/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingTransactionsBatchResponse {
    getFixupPrototypeFunction() { return MasterAccountBillingTransactionsBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingTransactionsBatchResponse>): MasterAccountBillingTransactionsBatchResponse {
        let obj = Object.assign(new MasterAccountBillingTransactionsBatchResponse(), model);
        MasterAccountBillingTransactionsBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingTransactionsBatchResponse>): MasterAccountBillingTransactionsBatchResponse {
        if (!model) return null;
        return MasterAccountBillingTransactionsBatchResponse.newInstance(<MasterAccountBillingTransactionsBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingTransactionsBatchResponse) {
        if (!obj) return;

        models.MasterAccountBillingTransactionsBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingTransactionsBatchResponse): boolean {
        Object.setPrototypeOf(obj, MasterAccountBillingTransactionsBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.MasterAccountBillingTransactionDocument.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.MasterAccountBillingTransactionDocument; };

}
